import PropTypes from 'prop-types';

import css from 'styles/components/account/infoCard/deleteOverlay.scss';

const DeleteOverlay = ({ cardInfoText, hideDeleteConfirmation, onDeleteClick }, { testId }) => (
  <div className={css.deleteOverlay}>
    <p>Are you sure you want to delete this {cardInfoText}?</p>
    <div>
      <button
        type="button"
        onClick={hideDeleteConfirmation}
        className={css.cancel}
        data-test-id={testId('cancelDeleteAddress')}>
        Cancel
      </button>
      <button
        type="button"
        onClick={onDeleteClick}
        className={css.delete}
        data-test-id={testId('confirmDeleteAddress')}>
        Confirm
      </button>
    </div>
  </div>
);

DeleteOverlay.contextTypes = {
  testId: PropTypes.func
};

export default DeleteOverlay;
